import moment from "moment";
import { util } from "../utils/utils";
import { StorageService } from '../../vue/services/StorageService'
class HotelAnalytics {
    constructor() {
        this.data = window.__pt.data || {};
        this.site = window.__pt.settings.site || {};
        this.culture = window.__pt.culture || {};
    }

    setHotelPaymentFunnel(args) {
        let base = this.getBaseData(args);

        let event = {
            eventAction: `CheckoutPax | hotelId:${base.hotelId} | ${base.hotelName} | ${base.placeName}`,
            eventCategory: "Hotels Payment Funnel",
            eventInteraction: false,
            eventLabel: `${base.checkinFormat} | ${base.checkoutFormat} | adults:${base.adults} | kids:${base.children} | ${base.type}`,
            eventValue: 0,
            event: "gtmEvent",
            eventName: "gtmEvent",
        };

        this.setDataLayer(event);
    }

    setHotelReservationDetail(args) {

        let base = this.getBaseData(args);
        let destinationName = base.placeText
            ? base.placeText.split(",").splice(1).join(",")
            : "_";

        let event = {
            ArrivalId: base.placeId,
            CheckIn: base.checkinFormat,
            CheckOut: base.checkoutFormat,
            ConversionCurrency: base.contractCurrency,
            Currency: base.currency,
            Destination:
                destinationName[0] == " " ? destinationName.substr(1) : destinationName,
            DestinationId: base.placeID,
            DestinationUrl: base.uriList,
            HotelId: base.hotelId,
            HotelName: base.hotelName,
            HotelUrl: base.uriDetail,
            ImageUrl: base.image,
            MealPlan: base.mealPlanName,
            ProductId: base.hotelPlaceId,
            Rapa: base.payNow,
            Rapd: base.isBookNowPayLater,
            RoomType: base.roomId,
            TotAmount: base.totalAmount,
            TotalAdults: base.adults,
            TotalAmount: base.totalAmount,
            TotalChilds: base.children,
            TotalRooms: base.roomsTotal,
            TripDays: base.days,
            Week: base.week,
            IsWeekend: base.isWeekend,
            Requote: base.requote,
            ConversionAmount: 0,
            eventName: "HotelReservationDetails_Remarketing",
            ArrivalName: "",
            PayForm: "",
            PayPlan: "",
            ReservationId: "",
            ChannelId: base.channelId,
            Category: "5",
            event: "checkoutStep1"
        };

        this.data.channelId = base.channelId;

        this.setDataLayer(event);

        let eventga4 = {
            event: "ga4.trackEvent",
            eventName: "add_to_cart",
            eventParams: {
                currency: base.currency,
                value: base.totalAmount,
                field_date1: base.checkIn,
                channel: base.channelId,
                field_date2: base.checkOut,
                field_rooms: base.roomsTotal,
                field_total_nights: base.days,
                field_destination: base.placeID,
                field_destination_name: ((base.placeText || ',').split(',')[1] || '').trim(),
                travelers_adults: base.adults,
                travelers_children: base.children,
                purchase_type: base.isBookNowPayLater ? "pagar despues" : "pagar ahora",
                content_type: "boton",
                page_type: "checkout_datos",
                layer: "hoteles",
                step: "1",
                timestamp: Date.now(),
                items: [
                    {
                        item_id: base.hotelId,
                        item_name: base.hotelName,
                        item_brand: base.uri,
                        item_category: 'hotel',
                        item_category2: null,
                        item_variant: null,
                        price: base.totalAmount,
                        coupon: base.coupon,
                        item_list_id: 0
                    }
                ]
            }
        };

        this.setDataLayer(eventga4);

    }

    getBaseData(args) {

        
        let data = {};
        let quote = args.quote || {};
        let place = args.places || {};
        let checkinMoment = moment(quote.checkIn);
        const dominio = window.location.origin;
        const listUri = `${this.site.siteUrl}/${this.culture.cultureCode}/${this.culture.pathHotelList}${place.destination}_d${place.destinationId}`;
        const DetailUri = `${this.site.siteUrl}/${this.culture.cultureCode}/${this.culture.pathHotelDetail}${place.uri}_a${place.id}`;
       
        data.adults = quote.adults;
        data.checkIn = quote.checkIn;
        data.checkOut = quote.checkOut;
        data.children = quote.children;
        data.culture = quote.culture;
        data.currency = quote.currency;
        data.days = quote.days;
        data.hotelId = quote.hotelId;
        data.image = quote.image;
        data.hotelName = quote.name;
        data.placeID = quote.placeID;
        data.quoteExpirationDate = quote.quoteExpirationDate;
        data.roomsTotal = quote.roomsTotal;
        data.stars = quote.stars;
        data.uri = quote.uri;
        data.bedding = quote.room.bedding;
        data.roomName = quote.room.name;
        data.roomImage = quote.room.image;
        data.roomId = quote.room.roomID;
        data.totalAmount = quote.rate.totalAmount;
        data.totalAmountOld = quote.rate.totalAmountOld;
        data.rateId = quote.rate.rateId;
        data.mealPlan = quote.rate.mealPlan;
        data.isBookNowPayLater = quote.rate.bookNowPayLater.isBookNowPayLater;
        data.detailIsBookNowPayLater = this.data.isBookNowPayLater;
        data.placeName = place.name;
        data.placeUri = place.uri;
        data.placeText = place.displayText;
        data.placeId = place.id;
        data.destination = place.destination;
        data.hotelPlaceId = quote.placeID;
        data.checkinFormat = moment(data.checkIn).format("YYYY-MM-DD");
        data.checkoutFormat = moment(data.checkOut).format("YYYY-MM-DD");
        data.type = data.isBookNowPayLater ? "RAPD" : "RAPA";
        data.payNow = data.type == "RAPA";
        data.week = moment(data.checkOut).week();
        data.mealPlanName = i18n.mealplans[quote.rate.mealPlan] || "";
        data.contractCurrency = quote.rate.contractCurrency;
        data.uriList = listUri;
        data.uriDetail = DetailUri;
        data.isWeekend = checkinMoment.day() === 6 || checkinMoment.day() === 0;
        data.requote = quote.rate.hasDifferentTotalAmount;
        data.channelId = quote.channelId;

        return data;
    }

    trackUserError(field, fieldsRules, parent) {
        let fieldsJoin = fieldsRules.errors.join(" - ");

        let event = {
            event: "gtmEvent",
            eventName: "user_error",
            eventCategory: "hoteles",
            eventAction: parent,
            eventLabel: field,
            eventExtra: fieldsJoin,
        };

        this.setDataLayer(event);
    }

    checkoutPaxes(data) {
        let event = {
            Firstname: data.name,
            Lastname: data.last_name,
            Email: data.email,
            Lada: data.dial_code,
            Phone: data.phone,
            Mobile: data.phone,
            ChannelId: this.data.channelId,
            eventName: "data_hotel_checkout_pax",
            event: "data_hotel_checkout_pax",
        };

        this.setDataLayer(event);
    }

    onError(error, data, step) {
        const error_sum = {
            m: error.message,
        };
        const quote_sum = {
            ra: data.IdRate,
            ro: data.IdRoom,
            h: data.IdHotel,
            ci: data.CheckIn,
            co: data.CheckOut,
            ca: data.CampaignToken,
            rapd: data.IsBookNowPayLater,
            rms: data.Rooms,
            pax: util.getStringPax(this.data.paxes),
        };

        const payload = JSON.stringify(error_sum || { results: "none" });
        const quote_params = JSON.stringify(quote_sum || { params: "none" });

        const event = {
            event: "gtmEvent",
            eventName: "gtmEvent",
            eventCategory: "Hotels Error",
            eventAction: quote_params,
            eventLabel: `step:${step} - ${payload}}`,
        };

        this.setDataLayer(event);
    }

    onError(error, data, step, retry_attempts = 0) {
        const error_sum = {
            m: error ? error.message : "error",
        };
        var pax =
            this.data && this.data.paxes ? util.getStringPax(this.data.paxes) : "";
        let checkIn = data.checkIn ? data.checkIn.split("T")[0] : "";
        let checkOut = data.checkOut ? data.checkOut.split("T")[0] : "";
        const quote_params = `a:${this.data.idHotel}|ro:${this.data.idRoom}|ra:${this.data.idRate}|ci:${checkIn}|co:${checkOut}|p:${pax}|r:${retry_attempts}|m:${error_sum.m}`;

        const event = {
            event: "gtmEvent",
            eventName: "gtmEvent",
            eventCategory: "Hotels Error",
            eventAction: step,
            eventLabel: quote_params,
        };
        this.setDataLayer(event);
    }

    discountEvent(args) {
        const quote = args.quote || {};
        const {
            currency = "",
            name = "",
            hotelId = "",
            checkIn = "",
            checkOut = "",
            roomsTotal = 0,
            adults = 0,
            children = 0,
            totalRate = {},
            margin
        } = quote;

        const event = {
            event: "trackEvent",
            eventName: "select_content",
            content_type: "boton",
            page_type: "checkout_datos",
            layer: "hoteles",
            moneda: currency,
            descuento: args.discount || 0,
            field_hotel_name: name,
            field_hotel_id: hotelId,
            field_date1: checkIn,
            field_date2: checkOut,
            field_rooms: roomsTotal,
            travelers_adults: adults,
            travelers_children: children,
            extra_info: `${StorageService.get("pt.margin_chk") || ""}|${margin || totalRate.margin}`

        };

        this.setDataLayer(event);
    }
    select_discount(args) {
        const quote = args.quote || {};
        const {
            totalRate = {},
            margin
        } = quote;
        const event = {
            event: "gtmEvent",
            eventName: "select_content",
            eventCategory: "hoteles",
            eventAction: "boton",
            eventLabel: "form:cupon_descuento",
            eventExtra: `${StorageService.get("pt.margin_chk") || ""}|${margin || totalRate.margin}`
        };

        this.setDataLayer(event);
    }
    select_discountBest(args) {
        const quote = args.quote || {};
        const {
            totalRate = {},
            margin
        } = quote;

        let event = {
            eventAction: `cupon_checkout`,
            eventCategory: "checkout",
            eventLabel: `${StorageService.get("pt.margin_chk") || ""}|${margin || totalRate.margin}`,
            eventName: "gtmEvent",
            event: "gtmEvent",
        };

        this.setDataLayer(event);
    }
    addShippingInfoTb(args) {
        let quote = args.quote || {};
        let place = args.places || {};
        let isBookNowPayLater = quote.rate.bookNowPayLater.isBookNowPayLater;

        let event = {
            event: "ga4.trackEvent",
            eventName: "add_shipping_info",
            eventParams: {
                currency: quote.currency,
                value: quote.rate.totalAmount,
                field_destination: quote.hotelId,
                field_date1: quote.checkIn,
                field_date2: quote.checkOut,
                field_rooms: quote.roomsTotal,
                field_total_nights: quote.days,
                travelers_adults: quote.adults,
                travelers_children: quote.children,
                purchase_type: isBookNowPayLater ? "pagar despues" : "pagar ahora",
                content_type: "boton",
                page_type: "checkout_datos",
                layer: "hoteles",
                timestamp: Date.now(),
                items: [
                    {
                        item_id: quote.room.roomID,
                        item_name: quote.room.name,
                        item_brand: quote.name,
                        item_category: "habitacion",
                        item_category2: null,
                        item_variant: null,
                        price: quote.rate.averageRateWithTaxes,
                        coupon: quote.rate.discount,
                        item_list_name: null,
                        item_list_id: 0,
                    },
                ],
            },
        };

        this.setDataLayer(event);
    }

    setThankYouPage(args) {
        let reservation = args.reservation;
        let quote = args.quote;
        let isBookNowPayLater = reservation.reserveNowPayLater;
        let info = args.info;
        let event = {
            event: "ga4.trackEvent",
            eventName: "purchase",
            eventParams: {
                currency: reservation.currency,
                value: reservation.hotelInformation.serviceAmountTotal,
                payment_type: "CreditCard",
                transaction_id: reservation.bookingId,
                arrival_id: quote.hotelId,
                field_destination: args.placeID,
                field_destination_name: args.quote.location.city,
                meal_plan: reservation.hotelInformation.mealPlan,
                purchase_type: isBookNowPayLater ? "pagar despues" : "pagar ahora",
                page_type: "confirmacion",
                layer: "hoteles",
                channel: reservation.channelId,
                timestamp: Date.now(),
                items: [
                    {
                        item_id: quote.hotelId,
                        item_name: quote.name,
                        item_brand: quote.uri,
                        item_category: "hotel",
                        item_category2: null,
                        coupon: reservation.hotelInformation.discount,
                        discount: reservation.hotelInformation.amountDiscount,
                        quantity: reservation.hotelInformation.roomsCount,
                        item_variant: null,
                        price: info.roomPrice,
                    },
                ],
            },
        };



        this.setDataLayer(event);
    }
    setErrorToken(valuesChange, args, token, id) {
        try {
            let { action, oldRate, newRate } = valuesChange;

            const { starting, returning } = args.flightItinerary;
            const { startingFrom, returningFrom } = args.extraInfoFlight;


            let event = {
                eventAction: id,
                eventCategory: "fingerprint",
                eventLabel: `${startingFrom}-${returningFrom}|${starting.airline}|${starting.scales}|${starting.fareGroup}|token:${token}`,
                eventName: "gtmEvent",
                event: "gtmEvent"
            }
            this.setDataLayer(event)

        } catch (error) {

        }

    }

    fingerPrint(token) {
        let event = {
            idfp: token,
            eventName: "fp",
            event: "fp"
        }
        this.setDataLayer(event)
    }

    setDataLayer(args) {
        if (window.dataLayer) {
            dataLayer.push(args);
        }
    }
}

export const HotelAnalytic = new HotelAnalytics();
